module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('img', {
    staticClass: "img-icon",
    attrs: {
      "src": "https://aiyaopai.com/404.png",
      "width": "200",
      "alt": ""
    }
  }), _vm._v(" "), _c('h1', [_vm._v("页面找不到咯")]), _vm._v(" "), _c('p', [_vm._v("我猜是程序猿也去现场凑热闹了")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73482aed"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Error.vue
// module id = 523
// module chunks = 1